export interface DividerWithButtonProps {
  inlineElement?: React.ReactNode;
  text: string;
  onClick: () => void | Promise<void>;
}

export const DividerWithButton = (props: DividerWithButtonProps) => {
  return (
    <div className="relative mt-12">
      <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-center">
        <button
          onClick={() => {
            props.onClick();
          }}
          type="button"
          className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-3 py-1.5 text-sm
          font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        >
          {props.inlineElement}
          {props.text}
        </button>
      </div>
    </div>
  );
};
